import React from "react";
import logo from "../../Components/Media/wp.png";
import image from "../../Components/Media/image.jpg";
import { Link } from "react-router-dom";
import { TextField } from "@mui/material";
import cbk from "../../Components/Media/cbk.jpg";

const Otp = () => {
  return (
    <div className="w-full h-full flex ">
     

      <div className="w-1/4 h-screen shadow-lg max-lg:hidden">
        <div className="h-4/5 px-6 flex flex-col  justify-center items-center rounded-lg ">
          <h2 className="text-center text-xl font-semibold">
            Hi, Welcome Back!
          </h2>
          <h6 className="text-center text-sm font-light text-gray-400 my-4">
            Keep tabs of your investments with Mywagepay
          </h6>
          <div className="w-2/3">
            <img src={image} alt="Investment" className="w-full h-full" />
          </div>{" "}
          <h6 className="text-xs flex items-center justify-start my-5 ">
            Licensed by
            <span className=" text-xs mx-1 font-semibold ">
              Central Bank of Kenya
            </span>
            <img src={cbk} alt="cbk licensed" className="w-8 h-8 rounded m-2" />
          </h6>
        </div>
      </div>
      <div className=" h-screen w-4/5 max-lg:w-full max-lg:mx-auto"> <img
        src={logo}
        alt="MyWagePay"
        className="w-16 h-12 mx-4 max-lg:block hidden"
      />
        <div className="h-4/5 px-6 flex flex-col align-middle  justify-center items-center ">
          <div className="w-1/2 max-lg:w-full   h-full mt-10 rounded-lg flex flex-col justify-center items-center pb-4">
            <div className="flex flex-col justify-evenly  items-center w-3/4 h-4/5 max-lg:w-11/12">
              <div className="flex flex-col justify-evenly items-start w-full mx-auto ">
                <h6 className=" font-semibold text-base mb-2">
                  Verify your account
                </h6>
                <h6 className=" font-normal text-sm text-gray-400">
                 Please enter the 4 digit code sent to your phone or email
                
                </h6>
              </div>
              <TextField
                id="outlined-basic"
                className="w-full h-10 m-4"
                label="OTP Code"
                type="number"
                variant="outlined"
              />
          
              <Link
                to="/overview"
                className="text-white bg-wageyellow w-full rounded h-10"
              >
                <button className="text-white bg-wageyellow w-full rounded h-10">
                  Sign in
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;
